module.exports = __webpack_public_path__ + "static/img/zhuanli06.e24fd53.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli06.png
// module id = TDYm
// module chunks = 1